import classes from "./Form.module.scss";

const Form = ({ children }) => {
  return (
    <div className={classes.form}>
      <div className={classes.formInnerCard}>{children}</div>
    </div>
  );
};

export default Form;
